import { useSwrFetch } from "./useSwrFetch";

interface UseQuoteCompetitivenessScoreResult {
  score: QuoteCompetitivenessScoreResponse | undefined;
  isLoading: boolean;
  error: string | null;
}

// docs/engineering/design/quote_competitiveness_scoring_design.md §14 — carrier-facing
// GET /quotes/{quote_id}/competitiveness-score.
export function useQuoteCompetitivenessScore(
  quoteId: number,
): UseQuoteCompetitivenessScoreResult {
  const { data, loading, error } =
    useSwrFetch<QuoteCompetitivenessScoreResponse>({
      url: `/quotes/${quoteId}/competitiveness-score`,
      errorMessage: "Failed to fetch quote competitiveness score",
    });

  return { score: data, isLoading: loading, error };
}
